import {
    DetailsPageContent,
    DetailsPageContentTabWrapper,
    DetailsPageWrapper
} from '@/components/ui/details-atoms/DetailsAtoms'
import {PatientDetailsHeader} from '@/features/patients/components/patient-details-header/PatientDetailsHeader'
import {PatientActivityLogs} from '@/features/entity-activity-logs/components/patient-activity-logs/PatientActivityLogs'
import {PatientDetailsTab} from '@/features/patients/components/patient-details-tab/PatientDetailsTab'
import {PatientExtended} from '@/features/patients/types'
import {Outlet, useOutletContext} from 'react-router-dom'

export const PatientDetailsLayout = () => {
    const {patient} = useOutletContext<{patient: PatientExtended}>()

    return (
        <DetailsPageWrapper isSuccess>
            <PatientDetailsHeader patient={patient} />
            <DetailsPageContent>
                <DetailsPageContentTabWrapper>
                    <PatientDetailsTab patient={patient} />
                    <Outlet context={{patient}} />
                </DetailsPageContentTabWrapper>
                <PatientActivityLogs />
            </DetailsPageContent>
        </DetailsPageWrapper>
    )
}
